/* 
Shows the Staking page, which has Orchestrator facts, Delegator info and staking functionalities
*/
import { Stack } from "@mantine/core";
import ViewSwitcher from "./ViewSwitcher";
import FactsList from "../components/PoolFacts/PoolFacts";
import { IconChartPie, IconBuildingBank, IconDiamond } from "@tabler/icons";
import DelegatorView from "../components/DelegatorTable/DelegatorView";
import LivepeerStaker from "../components/LivepeerStaker/LivepeerStaker";

export default function DelegatorPage(props) {
  return (
    <Stack spacing={"28px"} sx={{ marginLeft: "28px", marginRight: "28px" }}>
      <FactsList
        objects={[
          {
            title: "Fee Cut",
            logo: <IconChartPie size={32} color={"#86c232"} />,
            content:
              parseFloat(props.orchInfo.feeCutFloat * 100).toFixed(0) + "%",
            description:
              "The percentage of mined fees kept to pay out pool Transcoders. The remainder is distributed to our Delegators by ratio of their total stake",
          },
          {
            title: "Reward Cut",
            logo: <IconChartPie size={32} color={"#86c232"} />,
            content:
              parseFloat(props.orchInfo.rewardCutFloat * 100).toFixed(0) + "%",
            description:
              "The percentage of inflationary LPT rewards kept to fund the pool. The remainder is distributed to our Delegators by ratio of their total stake",
          },
          {
            title: "Total Stake",
            logo: <IconBuildingBank size={32} color={"#86c232"} />,
            content: parseFloat(props.orchInfo.totalStake).toFixed(0) + " LPT",
            description:
              "Total amount of LPT staked to the pool by our Delegators",
          },
          {
            title: "Fees Earned",
            logo: <IconDiamond size={32} color={"#86c232"} />,
            content:
              parseFloat(props.orchInfo.totalVolumeETH).toFixed(4) + " Eth",
            description:
              "Total amount of Eth transcoding fees earned by the pool and its historic Delegators",
          },
        ]}
      />
      <ViewSwitcher
        components={[
          <DelegatorView
            orchInfo={props.orchInfo}
            cachedENS={props.cachedENS}
          />,
          <LivepeerStaker
            orchInfo={props.orchInfo}
            allowance={props.allowance}
            currentRound={props.currentRound}
            ETHbalance={props.ETHbalance}
            LPTbalance={props.LPTbalance}
            bondedWith={props.bondedWith}
            delegatorState={props.delegatorState}
            bondedLPT={props.bondedLPT}
            thisProgress={props.thisProgress}
            transcoderTable={props.transcoderTable}
            isTranscoderTableErr={props.isTranscoderTableErr}
            refreshWallet={props.refreshWallet}
            getHints={props.getHints}
            connectWallet={props.connectWallet}
            connectedWallet={props.connectedWallet}
            locks={props.locks}
            checkIfWalletIsConnected={props.checkIfWalletIsConnected}
            pendingEth={props.pendingEth}
            isSyncing={props.isSyncing}
            cachedENS={props.cachedENS}
          />,
        ]}
      />
    </Stack>
  );
}
